import { useAppContext } from '@context/AppContext';
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";

export const useGlobalErrorHandler = () => {
    const { dispatch } = useAppContext();
    const { logout } = useKindeAuth();

    return () => {
        console.error('Realizando logout debido a error de autorización...');
        logout();
        dispatch({ type: 'LOGOUT' });
    };
};
